import { clearImpersonationCookie, isImpersonationSession } from '@/libs/impersonation';
import { tokenManager } from '@/libs/token-manager';
import { Box, Button, Flex, Portal, Text } from '@chakra-ui/react';
import { Alert } from '@fluenceur/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const BANNER_HEIGHT = '40px';

/**
 * The way out of an impersonation session stays on top of everything,
 * including a plan choice that cannot be closed: the banner is fixed above
 * every layer, and a spacer of its height keeps the page from sliding under it.
 */
export function ImpersonationBanner() {
  const { t } = useTranslation();
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    setIsImpersonating(isImpersonationSession());
  }, []);

  if (!isImpersonating) {
    return null;
  }

  const handleExit = () => {
    tokenManager.clearTokens();
    clearImpersonationCookie();
    window.location.href = '/';
  };

  return (
    <>
      <Box h={BANNER_HEIGHT} flexShrink={0} aria-hidden />
      <Portal>
        <Alert
          size="sm"
          status="warning"
          position="fixed"
          top="0"
          insetX="0"
          zIndex="max"
          h={BANNER_HEIGHT}
          py={2}
          borderRadius="0"
          justifyContent="center"
          fontSize="13px"
          pointerEvents="auto"
        >
          <Flex align="center" gap={2} gapX={4} justifyContent="center">
            <Text>{t('impersonation.banner')}</Text>
            <Button onClick={handleExit} variant="solid" size="xs">
              {t('impersonation.exit')}
            </Button>
          </Flex>
        </Alert>
      </Portal>
    </>
  );
}
